import { Injectable } from "@angular/core";
import { DocumentSigning } from "@models/documents/document-signing";
import { Approver, CarbonCopy, UpdateRecipientInfoModel } from "@models/documents/sign-documents";
import BaseApiService from "@shared/services/base/base-api.service";
import { Observable } from "rxjs";

@Injectable({ providedIn: 'root' })
export class DocumentSigningsApiService extends BaseApiService {
  getDocumentSigning(id: string): Observable<DocumentSigning> {
    return this.api.get<DocumentSigning>(`${ this.apiUrl }/document-signings/${ id }`);
  }

  deleteApprover(id: string): Observable<void> {
    return this.api.delete<void>(`${ this.apiUrl }/document-signings/${ id }/approver`);
  }

  addApprover(id: string, approver: Approver): Observable<void> {
    return this.api.post<void>(`${ this.apiUrl }/document-signings/${ id }/approver`, { approver });
  }

  updateCarbonCopies(id: string, carbonCopies: CarbonCopy[]): Observable<void> {
    return this.api.put<void>(`${ this.apiUrl }/document-signings/${ id }/carbon-copies`, carbonCopies);
  }

  updateRecipientInfo(updateModel: UpdateRecipientInfoModel): Observable<void> {
    return this.api.post<void>(`${ this.apiUrl }/document-signings/recipient-info/update`, updateModel);
  }
}
